module.exports = [
  {
    id: 'size',
    options: [
      { value: 'small' },
      { value: 'medium' },
      { value: 'large' },
      { value: 'wallpaper' },
    ],
    size: 'm',
  },
  {
    id: 'color',
    type: 'color',
    options: [
      { value: 'colorOnly' },
      { value: 'monochrome' },
      { value: 'red', color: '#d63232' },
      { value: 'orange', color: '#ff7950' },
      { value: 'yellow', color: '#fdd12c' },
      { value: 'green', color: '#55b720' },
      { value: 'teal', color: '#14a7ab' },
      { value: 'blue', color: '#0b68c4' },
      { value: 'purple', color: '#9a48bd' },
      { value: 'pink', color: '#ff99cc' },
      { value: 'brown', color: '#805a3f' },
      { value: 'black', color: '#1d1d1d' },
      { value: 'gray', color: '#bbbbbb' },
      { value: 'white', color: '#ffffff' },
    ],
    size: 'm',
  },
  {
    id: 'imageType',
    options: [
      { value: 'photo' },
      { value: 'clipart' },
      { value: 'line' },
      { value: 'animatedgif' },
      { value: 'transparent' },
    ],
    size: 'm',
  },
  {
    id: 'freshness',
    options: [
      { value: 'day' },
      { value: 'week' },
      { value: 'month' },
    ],
    size: 'm',
  },
  {
    id: 'aspect',
    options: [
      { value: 'square' },
      { value: 'wide' },
      { value: 'tall' },
    ],
    size: 'm',
  },
  {
    id: 'license',
    options: [
      { value: 'share' },
      { value: 'shareCommercially' },
      { value: 'modify' },
      { value: 'modifyCommercially' },
      { value: 'public' },
    ],
    size: 'l',
  },
];
